import * as React from "react";
import { StockIndicator } from "@grandvisionhq/inventory";
import { useFeatureToggles } from "@grandvisionhq/state";
import { useEcommFacetContext } from "../../../../../../context/modules/EcommContent/context/EcommFacetContext.js";
import { isFramesVariant } from "../../../../../../../../types/types/typeguards.js";
import { useProductData } from "../../../../../../../../context/context/product-context-hooks.js";
const VariantTreeStockIndicator = ({ treeLevelVariants, facetKey }) => {
  const { activeVariant, facetConfigList } = useProductData();
  const { isPrescriptionGlassesEnabled } = useFeatureToggles();
  const { clickedFacetKeys } = useEcommFacetContext();
  const { stock, channelAvailability, isExcludedFromCheckout } = activeVariant;
  const facetConfig = facetConfigList?.find((config) => config.facetKey === facetKey);
  const isLastTreeLevel = treeLevelVariants.every(
    (variant) => variant.childFacets.length === 0 || variant.childFacets.every((childFacet) => childFacet.facetTerm === null)
  );
  if (!facetConfig || !facetKey) return null;
  const { requiresUserSelection } = facetConfig;
  const hasBeenSelected = Boolean(
    clickedFacetKeys?.includes(facetKey) || !requiresUserSelection || treeLevelVariants.length <= 1
  );
  const isSellableProduct = !isFramesVariant(activeVariant) || isPrescriptionGlassesEnabled;
  const shouldRender = Boolean(
    stock.enableStockIndicator && !isExcludedFromCheckout && hasBeenSelected && isLastTreeLevel && isSellableProduct
  );
  if (!shouldRender) return null;
  return /* @__PURE__ */ React.createElement(
    StockIndicator,
    {
      stockCount: stock.stockCount,
      allowBackOrder: stock.isAllowBackOrder,
      channelAvailability
    }
  );
};
export {
  VariantTreeStockIndicator
};
//# sourceMappingURL=VariantTreeStockIndicator.js.map
